import React, { useEffect } from 'react';
import "./home-superior360.component.scss";
import * as PANOLENS from "panolens";
import * as THREE from "three";

import imgPisoSuperior from '../../../assets/panolens/piso-superior.jpg';
import imgInfoSpot from '../../../assets/panolens/info-spot.png';
import imgInfoSpotPiso from '../../../assets/panolens/pt-chao.png';
import { SnackService } from '../../../services/snack.service';
import { sendEvent } from '../../../scripts/events';
import { LoadVideoBgService } from '../../../services/load-video-bg.service';
import { ROTAVIDEOS } from '../../../constants/rotas-videos.constant';

import icoPanoOff from '../../../assets/panolens/ico-pano-off.svg';
import icoPanoOn from '../../../assets/panolens/ico-pano-on.svg';
import { Button } from '@material-ui/core';
import { Ativa360Service } from '../../../services/ativa360.service';

const panoramaSuperior = new PANOLENS.ImagePanorama(imgPisoSuperior);

const viewerSuperior = new PANOLENS.Viewer({
    container: document.querySelector("#home-superior"),
    controlBar: true,
    autoHideInfospot: false
});

viewerSuperior.add(panoramaSuperior);
viewerSuperior.getCamera().fov = 120;
viewerSuperior.getCamera().updateProjectionMatrix();
//viewerSuperior.OrbitControls.noZoom = true;
// posição inicial camera
viewerSuperior.camera.position.set(-0.37762263011158637, 0.1075657714400121, 0.91969057516217);
document.querySelector(".panolens-container").classList.add('superior');

let x = 50;
let y = -130;
let z = -150;

const createInfoSpotSuperior = (pos: any, img: any, hoverTxt: string, send_event: any, nome_video: any) => {
    let position = new THREE.Vector3(pos.x, pos.y, pos.z);
    let infospot = new PANOLENS.Infospot(30, img, false);
    infospot.position.copy(position);
    infospot.addHoverText(hoverTxt);
    infospot.addEventListener('click', () => {
        sendEvent(send_event);
        localStorage.setItem('urlFrom', 'homeSuperior')
        LoadVideoBgService.sendNomeVideo(nome_video);
    });
    panoramaSuperior.add(infospot);
}

// Produtividade
createInfoSpotSuperior(
    { x: 190, y: 70, z: -370 },
    imgInfoSpot,
    'Produtividade',
    { category: 'home', label: 'menu_pts_produtividade', action: 'click' },
    ROTAVIDEOS.produtividade
);

// Risco
createInfoSpotSuperior(
    { x: -30, y: 70, z: -430 },
    imgInfoSpot,
    'Risco',
    { category: 'home', label: 'menu_pts_risco', action: 'click' },
    ROTAVIDEOS.risco
);

// Negócios
createInfoSpotSuperior(
    { x: -190, y: 50, z: -290 },
    imgInfoSpot,
    'Negócios',
    { category: 'home', label: 'menu_pts_negocios', action: 'click' },
    ROTAVIDEOS.negocios
);

// Inovação
createInfoSpotSuperior(
    { x: -290, y: 50, z: -170 },
    imgInfoSpot,
    'Inovação',
    { category: 'home', label: 'menu_pts_inovacao', action: 'click' },
    ROTAVIDEOS.inovacao
);

// Fox Xpro
createInfoSpotSuperior(
    { x: -110, y: -10, z: -190 },
    imgInfoSpot,
    'Fox Xpro',
    { category: 'home', label: 'menu_pts_foxXpro', action: 'click' },
    ROTAVIDEOS.foxXpro
);

// Visão Risco
// createInfoSpotSuperior(
//     { x: -70, y: -230, z: -150 },
//     imgInfoSpotPiso,
//     'Visão Risco',
//     { category: 'home', label: 'menu_pts_visao_risco', action: 'click' },
//     ROTAVIDEOS.homeRisco
// );

let positionPadrao = new THREE.Vector3(210, -80, -210);
let infospotPadrao = new PANOLENS.Infospot(30, imgInfoSpotPiso, false);
infospotPadrao.position.copy(positionPadrao);
infospotPadrao.addHoverText('Infospot padrao');
infospotPadrao.addEventListener('click', () => { });
//panoramaSuperior.add(infospotPadrao);

var UA = navigator.userAgent;

export default function HomeSuperior360Component() {

    const [isAndroid, setIsAndroid] = React.useState<boolean>(/\b(Android|iPhone|Windows Phone|iPad|iPod|BlackBerry|webOS)\b/i.test(UA));
    const [isIos, setIsIos] = React.useState<boolean>(/\b(iPhone|iPad|iPod)\b/i.test(UA));
    const [toggleOculus, setToggleOculus] = React.useState<boolean>(Ativa360Service.get360Ativo());

    useEffect(() => {
        //viewerSuperior.add(panoramaSuperior);
        if (toggleOculus) {
            viewerSuperior.enableControl(1);
            viewerSuperior.enableEffect( PANOLENS.MODES.CARDBOARD);
        } else {
            viewerSuperior.enableControl(0);
            viewerSuperior.enableEffect( PANOLENS.MODES.NORMAL);
        }

    }, []);

    document.addEventListener('keydown', function (e: any) {
        //console.log(e.keyCode);
        switch (e.keyCode) {
            case 65:
                //alert('left'); ---- A
                x -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 68:
                //alert('right'); ---- D
                x += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 87:
                //alert('up'); ---- W
                y += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 83:
                //alert('down'); ---- S
                y -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 90:
                //alert('profundidade'); ---- Z
                z += 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                break;
            case 88:
                //alert('profundidade'); ---- X
                z -= 10;
                positionPadrao = new THREE.Vector3(
                    x,
                    y,
                    z
                );
                infospotPadrao.position.copy(positionPadrao);
                console.log(positionPadrao);
                break;
            case 84:
                //alert('profundidade'); ---- T
                // tecla T para debugar posição inicial que deseja
                console.log(viewerSuperior.camera.position);
                break;
        }
    });

    const toggleOculusFunc = () => {

        if (!toggleOculus) {
            if (isIos) {
                (DeviceMotionEvent as any).requestPermission();
            }
            viewerSuperior.enableControl(1);
            viewerSuperior.enableEffect( PANOLENS.MODES.CARDBOARD);
        } else {
            viewerSuperior.enableControl(0);
            viewerSuperior.enableEffect( PANOLENS.MODES.NORMAL);
        }

        setToggleOculus(!toggleOculus);
        Ativa360Service.toggle360Ativo();
    }

    return (
        <>
            <div id="home-superior">
                { }
                <img className='seta-frente' src={imgInfoSpotPiso} onClick={() => {
                    sendEvent({ category: 'home', label: 'menu_pts_visao_risco', action: 'click' });
                    LoadVideoBgService.sendNomeVideo(ROTAVIDEOS.homeRisco);
                }} />
            </div>

            {
                // isAndroid &&
                // <Button onClick={toggleOculusFunc} className={'bt-oculus ativo-' + toggleOculus}>
                //     <img className='pano-off' src={icoPanoOff} />
                //     <img className='pano-on' src={icoPanoOn} />
                // </Button>
            }
        </>
    );
}